import { AddEditProductCategory as Page } from './AddEditProductCategory.main';

export const AddEditProductCategory = { Page };
